import axios from "axios";
import { resolveSiteSlug } from "@/config/siteConfig";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve an image URL that could be:
 *   - a base64 data URL (`data:image/png;base64,...`) → returned as-is (legacy)
 *   - a fully-qualified HTTPS URL → returned as-is
 *   - a backend-relative path like `/api/files/wofy/...` → prefixed with backend origin
 *   - falsy → returns empty string
 */
export function resolveImage(url) {
  if (!url) return "";
  if (typeof url !== "string") return "";
  if (url.startsWith("data:") || url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_ORIGIN}${url}`;
  return url;
}

// httpOnly cookies flow automatically with withCredentials; do not touch localStorage for tokens.
export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Public / read-only axios instance — no credentials and no custom
// headers, which keeps GET requests "simple" per the CORS spec and
// therefore preflight-free. Use this for public data reads
// (obituaries lists, family trees index, heritage content, etc.)
// so cross-origin child sites (indianfamilytree.com, foodpulse.net)
// can render even when the deployed backend's OPTIONS handler is
// misbehaving (Cloudflare 520 issue). Anything requiring auth or
// mutation MUST still use `http` above.
export const httpPublic = axios.create({
  baseURL: API,
  // withCredentials defaults to false — no cookies sent.
});

// Stamp every outgoing API call with the current sibling site so
// backend endpoints (bookmarks, guide claims, POI uploads…) can
// attribute writes to the right child. Reads the resolver each
// request, so a mid-session `?site=` change is respected.
http.interceptors.request.use((cfg) => {
  try {
    const q = typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("site")
      : null;
    const slug = resolveSiteSlug({ queryParam: q || "" });
    cfg.headers = cfg.headers || {};
    if (!cfg.headers["X-Site-Source"]) cfg.headers["X-Site-Source"] = slug;
  } catch { /* non-fatal */ }
  return cfg;
});

